import { render, staticRenderFns } from "./xtRadio.vue?vue&type=template&id=6f78810f&scoped=true&"
import script from "./xtRadio.vue?vue&type=script&lang=js&"
export * from "./xtRadio.vue?vue&type=script&lang=js&"
import style0 from "./xtRadio.vue?vue&type=style&index=0&id=6f78810f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f78810f",
  null
  
)

export default component.exports